import { render, staticRenderFns } from "./crearRiesgoBowtie.vue?vue&type=template&id=50eacb06&"
import script from "./crearRiesgoBowtie.vue?vue&type=script&lang=js&"
export * from "./crearRiesgoBowtie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "crearRiesgoBowtie.vue"
export default component.exports